"use client";

import { useEffect, useState } from "react";

type ViewMode = "AI" | "MANUAL";

const STORAGE_KEY = "booking-view-preference";

export const useBookingViewPreference = () => {
    const [preferredView, setPreferredView] = useState<ViewMode | null>(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored === "AI" || stored === "MANUAL") {
                setPreferredView(stored);
            }
        } catch {
            // localStorage not available (e.g., private browsing)
        }
        setIsLoaded(true);
    }, []);

    const savePreference = (view: ViewMode) => {
        try {
            localStorage.setItem(STORAGE_KEY, view);
            setPreferredView(view);
        } catch {
            // localStorage not available
        }
    };

    return { preferredView, savePreference, isLoaded };
};
